// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-info {
    margin-bottom: 32px;
}

.audit-window {
    height: 25vh;
    border-radius: 4px;
    border: 1px solid #ecebeb;
    width: 100%;
    overflow-y: scroll;
}

.legend {
    margin: 16px 0 0 0;
}

.legend .legend-header {
    margin: 0 0 8px 0;
}

.legend .legend-label {
    width: 100%;
}

.legend .legend-box {
    width: 100px;
    border-radius: 5px;
    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
    border: 1px dimgrey solid;
    text-align: center;
    color: black;
}

.audit-window .perm-category {
    font-weight: 500;
    margin: 4px 0;
    padding: 4px 8px;
}

.audit-window .perm {
    margin: 4px 8px;
    padding: 4px;
    color: black;
    border: none;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/utils/confirm.userpermissions.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".audit-info {\n    margin-bottom: 32px;\n}\n\n.audit-window {\n    height: 25vh;\n    border-radius: 4px;\n    border: 1px solid #ecebeb;\n    width: 100%;\n    overflow-y: scroll;\n}\n\n.legend {\n    margin: 16px 0 0 0;\n}\n\n.legend .legend-header {\n    margin: 0 0 8px 0;\n}\n\n.legend .legend-label {\n    width: 100%;\n}\n\n.legend .legend-box {\n    width: 100px;\n    border-radius: 5px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;\n    border: 1px dimgrey solid;\n    text-align: center;\n    color: black;\n}\n\n.audit-window .perm-category {\n    font-weight: 500;\n    margin: 4px 0;\n    padding: 4px 8px;\n}\n\n.audit-window .perm {\n    margin: 4px 8px;\n    padding: 4px;\n    color: black;\n    border: none;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
